import { render, staticRenderFns } from "./SubmissionShared.vue?vue&type=template&id=81bfb16c&scoped=true&"
import script from "./SubmissionShared.vue?vue&type=script&lang=js&"
export * from "./SubmissionShared.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionShared.vue?vue&type=style&index=0&id=81bfb16c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bfb16c",
  null
  
)

export default component.exports